export default "__VITE_ASSET__BbRHIBqE__"